'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushCartUpsell = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _functional = require('../../../utils/functional');

var _Ui = require('../Ui');

var _PushCartUpsellItem = require('./PushCartUpsellItem');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var PushCartUpsell = function PushCartUpsell(_ref) {
  var title = _ref.title,
      expand = _ref.expand,
      setExpand = _ref.setExpand,
      upsellItems = _ref.upsellItems;

  var onExpand = function onExpand() {
    sessionStorage.setItem('upsellCollapsed', expand);
    setExpand(!expand);
  };
  function getConfig() {
    return JSON.parse((0, _functional.getElement)('#CartConfig').innerHTML);
  }

  var _getConfig = getConfig(),
      useNewPushcartDesign = _getConfig.useNewPushcartDesign;

  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)('psh-Upsell', {
      'psh-Upsell-expanded': expand
    })
  }, _react2.default.createElement('div', { className: 'psh-Upsell_Header util-No-select', onClick: onExpand }, title, _react2.default.createElement('span', { className: 'psh-Upsell_Chevron' }, _react2.default.createElement('span', { className: 'am-icon-chevron' }))), _react2.default.createElement('div', { className: 'psh-Upsell_Body' }, _react2.default.createElement('div', { className: 'prd-AdditionalProducts_Items prd-AdditionalProducts_Items-pl' }, _react2.default.createElement(_Ui.Carousel, {
    className: 'car-Static psh-Upsell_Carousel',
    useNavigation: upsellItems.length > 2 && useNewPushcartDesign,
    loop: false,
    spaceBetween: 24,
    slideClassName: 'psh-Upsell_Slide',
    initialSlide: 0,
    centeredSlides: false,
    breakpoints: {
      300: {
        slidesPerView: 1.6
      },
      768: {
        slidesPerView: 2
      }
    }
  }, upsellItems.map(function (item) {
    return _react2.default.createElement(_PushCartUpsellItem.PushCartUpsellItem, {
      key: item.id,
      variantId: item.id,
      title: item.title,
      handle: item.handle,
      image: item.image,
      price: item.price,
      compareAtPrice: item.compare_at_price,
      unitPriceMeasurement: item.unit_price_measurement,
      vendor: item.vendor,
      reviewsRating: item.reviews && item.reviews.rating,
      useNewPushcartDesign: useNewPushcartDesign
    });
  })))));
};

PushCartUpsell.propTypes = {
  title: _propTypes2.default.string,
  expand: _propTypes2.default.bool.isRequired,
  setExpand: _propTypes2.default.func.isRequired,
  upsellItems: _propTypes2.default.array.isRequired
};

exports.PushCartUpsell = PushCartUpsell;